import React from 'react';
import { useTheme } from '../../../../contexts/ThemeContext';
import { cn } from '../../../../lib/utils';
import { Card, CardContent, CardHeader, CardTitle } from '../../../../components/ui';
import { FileIcon } from '../../../../components/ui/Icons';
import { API_ENDPOINTS } from '../../../../config/apiConfig';
import { normalizeFileName } from '../../../../components/ui/utils/fileNameEncoding';

const MyProceduresFilesTab = ({ files = [], revisionVersion, canView }) => {
  const { theme } = useTheme();
  const activeFiles = (files || []).filter((f) => !f.isDeleted);

  if (!canView) {
    return (
      <div className="p-4">
        <p className="text-sm text-amber-700 dark:text-amber-300 bg-amber-50 dark:bg-amber-900/20 p-3 rounded-lg">
          Files are available after QMS publishes this procedure.
        </p>
      </div>
    );
  }

  if (!activeFiles.length) {
    return (
      <div className="p-4">
        <p className={cn('text-sm', theme.text.secondary)}>
          No files on revision {revisionVersion || '—'}.
        </p>
      </div>
    );
  }

  return (
    <div className="p-4 flex-1 overflow-y-auto">
      <Card>
        <CardHeader>
          <CardTitle className="text-base flex items-center">
            <FileIcon className="w-4 h-4 mr-2" />
            Revision {revisionVersion || '—'} files ({activeFiles.length})
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-2 max-h-[calc(100vh-16rem)] overflow-y-auto">
            {activeFiles.map((file) => (
              <div
                key={file.id}
                className={cn(
                  'flex items-center gap-3 p-2 rounded-lg border',
                  theme.colors.background,
                  theme.border.subtle
                )}
              >
                <FileIcon className="w-4 h-4 text-blue-500 shrink-0" />
                <div className="flex-1 min-w-0">
                  <div className={cn('text-sm font-medium truncate', theme.text.primary)}>
                    {normalizeFileName(file.fileName || '')}
                  </div>
                  <div className={cn('text-xs', theme.text.secondary)}>
                    {file.fileSize
                      ? `${(file.fileSize / 1024 / 1024).toFixed(2)} MB`
                      : 'Unknown size'}{' '}
                    · {file.fileType || 'Unknown type'}
                  </div>
                </div>
                <a
                  href={API_ENDPOINTS.fileAttachment.download(file.id)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={cn(
                    'text-xs px-3 py-1 rounded-md transition-colors shrink-0',
                    theme.colors.primary,
                    theme.text.inverse,
                    'hover:opacity-80'
                  )}
                  onClick={(e) => e.stopPropagation()}
                >
                  Download
                </a>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default MyProceduresFilesTab;
